import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clientActionsSaga } from '../../../../infrastructure/services/client';
import { clientActions } from '../../../../application/actions/client';
import { documentsActionsSaga } from '../../../../infrastructure/services/documents'
import { documentsActions } from '../../../../application/actions/documents';
import AvatarList from '../../molecula/AvatarList/AvatarList';
import CreateForms from '../../organismos/forms';
import Modal from '../../molecula/modal/Modal';
import 'moment/locale/es';
import './index.css'
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import { Box, Grid, Button, Typography, ButtonGroup } from '@mui/material';
import GradientCircularLoader from '../../molecula/circularLoader/circularLoader';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Alert from '@mui/material/Alert';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';




const fabStyle = {
  position: 'absolute',
  bottom: 16,
  right: 16,
};

const ClientsTemplate = () => {
  const dispatch = useDispatch();
  /*SHOW ALL DATA*/
  const { data: getAll, connection: connectionGetAll } = useSelector((store) => store.tk.client.getAll);
  /*SHOW DOCUMENT FOR BY ID CLIENT  */
  const { data: dataDocuments } = useSelector((store) => store.tk.documents.getById);

  /*SHOW BY ID AND UPDATE DATA*/
  const { connection: connectionById, data: clientById } = useSelector((store) => store.tk.client.getById);
  const { connection: connectionUpdate, result: resultUpdate } = useSelector((store) => store.tk.client.update);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [openUpdateHome, setOpenUpdateHome] = useState(false);
  const [habilityUpdate, setHabilityUpdate] = useState(false);
  const [updateClient, setUpdateClient] = useState({}); //DATA PARA ENVIO
  const [showClient, showUpdateClient] = useState([]); //FORM JSON

  /*LOAD FILE*/
  const [habilityLoadFile, setHabilityLoadFile] = useState(false);
  const [createLoadFile, setCreateLoadFile] = useState({});
  const { connection: connectionCreateDocuments, result: resultCreateDocuments, error: errorCreateDocuments, message: messageCreateDocuments } = useSelector((store) => store.tk.documents.create);
  /*CREATE DATA*/
  const { region, province, comuna } = useSelector((store) => store.tk.globalData.location.data);
  const { connection: connectionCreate, result: resultCreate } = useSelector((store) => store.tk.client.create);
  const [openCreate, setOpencreate] = useState(false);
  const [habilityCreate, setHabilityCreate] = useState(false);
  const [createClient, setCreateClient] = useState({});
  const formulario = [{
    name: 'Cliente',
    groups: [
      {
        title: 'Datos de la empresa',
        size: { xs: 12, sm: 12, md: 12 },
        display: true,
        fields: [
          {
            id: 'nameComapny',
            label: 'Cliente',
            kind: 'text',
            required: true,
            size: { xs: 12, sm: 12, md: 12 }
          },
          {
            id: 'numberId',
            label: 'Rut',
            kind: 'numberId',
            required: true,
            validations: ['CL'],
            size: { xs: 12, sm: 5, md: 5 }
          },
          {
            id: 'phone',
            label: 'Telefono',
            kind: 'phone',
            required: true,
            validations: ['CL'],
            size: { xs: 12, sm: 7, md: 7 }
          },
          {
            id: 'idRegion',
            label: 'Region',
            kind: 'fieldListSearch',
            required: true,
            options: region,
            size: { xs: 12, sm: 12, md: 12 }
          },
          {
            id: 'idComuna',
            label: 'Comuna',
            kind: 'fieldListSearch',
            required: true,
            options: comuna,
            size: { xs: 12, sm: 6, md: 6 }
          },
          {
            id: 'idCity',
            label: 'Ciudad',
            kind: 'fieldListSearch',
            required: true,
            options: province,
            size: { xs: 12, sm: 6, md: 6 }
          },
          {
            id: 'directions',
            label: 'Direccion',
            kind: 'text',
            required: true,
            size: { xs: 12, sm: 12, md: 12 }
          },
          {
            id: 'email',
            label: 'Email',
            kind: 'email',
            required: true,
            size: { xs: 12, sm: 12, md: 12 }
          }

        ],
      },
      {
        title: 'Datos de contacto',
        size: { xs: 12, sm: 12, md: 12 },
        display: true,
        fields: [
          {
            id: 'numberIdOwner',
            label: 'Rut de el contacto',
            kind: 'text',
            required: true,
            validations: ['CL'],
            size: { xs: 12, sm: 5, md: 5 }
          },
          {
            id: 'nameOwner',
            label: 'Nombre de contacto',
            kind: 'text',
            required: true,
            size: { xs: 12, sm: 7, md: 7 }
          },
          {
            id: 'patherNameOwner',
            label: 'Apellido paterno de el contacto',
            kind: 'text',
            required: true,
            size: { xs: 12, sm: 6, md: 6 }
          },
          {
            id: 'motherNameOwner',
            label: 'Apellido materno de el contacto',
            kind: 'text',
            required: true,
            size: { xs: 12, sm: 6, md: 6 }
          },

        ],
      },
    ],
  }];

  const fromFile = [{
    name: 'Cliente',
    groups: [
      {
        title: 'Plantillas de documento',
        size: { xs: 12, sm: 12, md: 12 },
        display: true,
        fields: [
          {
            id: 'files',
            label: 'Nombre de Plantilla',
            kind: 'file',
            required: true,
            size: { xs: 12, sm: 12, md: 12 }
          }
        ],
      },
    ],
  }];

  /*SHOW ALL */
  const getAllItems = () => {
    dispatch(clientActionsSaga.getAll());
  }

  useEffect(() => {
    getAllItems()
  }, []);

  const mapAvatarList = (data) => {
    const map = []
    data.map(x => map.push({
      id: x.id,
      title: x.nameComapny,
      subTitle: x.numberId,
      details: x.directions
    }));
    return map;

  }

  /*SHOW DOCUMENT FOR BY ID CLIENT */

  const handlreGetDocumentByIdClient = () => {
    clientById.id  && dispatch(documentsActionsSaga.getById({ id: clientById.id }));
  };


  /*SHOW BY ID AND UPDATE */


  const handleFindClienById = (id) => {
    setOpenUpdateHome(false)
    dispatch(clientActionsSaga.getById({ id }));
    dispatch(documentsActionsSaga.getById({ id }));
    dispatch(documentsActions.createReset())
  }

  const handlerShowAndupdate = () => {
    const status = openUpdate
    setOpenUpdate(!status)
    if (status) {
      //dispatch(clientActions.getById({}))
      setUpdateClient([])
    }
  }


  const handleUpdate = () => {
    const createData = {}
    updateClient.map((F) => F.groups.map(G => G.fields.map(F => createData[F.id] = F.value)))
    createData['id'] = clientById.id;
    dispatch(clientActionsSaga.update(createData));
  }

  const buttonUpdate = <ButtonGroup  fullWidth ><Button sx={{ml:2, mr:2}} disabled={!habilityUpdate || connectionUpdate} onClick={handleUpdate}>Actualizar</Button></ButtonGroup>

  useEffect(() => {
    if (clientById.id && !connectionById) {
      const setform = formulario;
      setform.map((F) => F.groups.map(G => G.fields.map(F => {
        F.value = clientById[F.id]
      })))
      showUpdateClient(setform)
      handlerShowAndupdate()
      setOpenUpdateHome(true)
    }

  }, [clientById, connectionById]);

  const getFieldsUpdate = (get) => {
    setUpdateClient(get)
  };
  const getEnabledFormUpdate = (flag) => {
    setHabilityUpdate(flag)
  };


  const showClientForm = <CreateForms
    fields={showClient}
    getFields={getFieldsUpdate}
    getEnabledForm={getEnabledFormUpdate}
    loader={connectionUpdate}
  />


  const reloadStates = () => {
    dispatch(clientActions.createReset())
    dispatch(clientActions.updateReset())
    getAllItems()
  }

  useEffect(() => {
    (resultUpdate || resultCreate) && reloadStates()
    setOpencreate(false)
    setOpenUpdate(false)
  }, [resultUpdate, resultCreate]);

  /*CREATE*/
  const handleShowModalCreate = (e) => {
    setOpencreate(!openCreate)
  }

  const getFieldsCreate = (get) => {
    setCreateClient(get)
  };

  const getEnabledFormCreate = (flag) => {
    setHabilityCreate(flag)
  };

  const creation = <CreateForms
    fields={formulario}
    getFields={getFieldsCreate}
    getEnabledForm={getEnabledFormCreate}
    loader={connectionCreate}
  />

  const handleCreate = () => {
    const createData = {}
    createClient.map((F) => F.groups.map(G => G.fields.map(F => createData[F.id] = F.value)))
    dispatch(clientActionsSaga.create(createData));
  }
  const buttonCreate = <Button disabled={!habilityCreate || connectionCreate} onClick={handleCreate}>Crear Cliente</Button>

  const [value, setValue] = React.useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };



  const getFieldsFileLoad = (get) => {
    console.log(get)
    dispatch(documentsActions.createReset())
    setCreateLoadFile(get)
  }

  const getEnabledFormFileLoad = (flag) => {
    setHabilityLoadFile(flag)
  }

  /*DOCUMENTO */
  const createDocument = () => {

    const createDataFile = { clientId: clientById.id, documentName: createLoadFile[0].groups[0].fields[0].file.name }
    createLoadFile.map((F) => F.groups.map(G => G.fields.map(F => createDataFile[F.id] = F.value)))


    dispatch(documentsActions.createReset())
    dispatch(documentsActionsSaga.create(createDataFile));

  }


  useEffect(() => {
    handlreGetDocumentByIdClient();
  }, [resultCreateDocuments])


  const buttonLoadFile = <ButtonGroup fullWidth ><Button sx={{ ml: 2, mr: 2 }} disabled={!habilityLoadFile || connectionCreateDocuments} onClick={createDocument}>Publicar Plantilla</Button></ButtonGroup>


  const showFile = <CreateForms
    fields={fromFile}
    getFields={getFieldsFileLoad}
    getEnabledForm={getEnabledFormFileLoad}
    loader={connectionUpdate}
  />

  const edit = () => {
    return <>
      <Grid sx={{ backgroundColor: '#6a6a6a', height: 'auto', p: 1, marginLeft: -2, paddingLeft: 4, paddingTop: 2 }}>
        <Typography sx={{ color: '#dcdcdc', fontSize: 25, }}>Cliente: {openUpdateHome && clientById.nameComapny}</Typography>
      </Grid>
      <Grid container >
        <Box sx={{ width: '100%', typography: 'body1' }} >
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleChange} aria-label="lab API tabs example">
                <Tab label="Datos del cliente" value="1" />
                <Tab label="Plantillas" value="2" />
              </TabList>
            </Box>
            <TabPanel value="1">
              <Grid container >
                <Grid xs={12} sm={6} md={6}>
                  {showClientForm}
                  {buttonUpdate}
                </Grid>
              </Grid>
            </TabPanel>
            <TabPanel value="2" >
              <Grid container >
                <Grid xs={12} sm={6} md={6}>
                  {showFile}
                  {errorCreateDocuments && <Alert sx={{ ml: 2, mr: 2, mb: 2 }} severity="error">{messageCreateDocuments}</Alert>}
                  {resultCreateDocuments && <Alert sx={{ ml: 2, mr: 2, mb: 2 }} severity="success">Plantilla creada con exito</Alert>}
                  {buttonLoadFile}
                </Grid>

                <Grid xs={12} sm={6} md={6}>
                  <Typography
                    sx={{
                      pt: 0, pb: 0, pl: 2, pr: 2, mb: 0,
                    }}
                    variant="h6"
                    component="p"
                  >
                    Plantillas disponibles
                  </Typography>
                  <Stack spacing={1} sx={{ p: 2 }}>
                    {dataDocuments.map(option => (
                      <Chip label={option.name} />
                    ))}
                  </Stack>
                </Grid>
              </Grid>
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
    </>
  }


  return (
    <>
      {(connectionById || connectionCreateDocuments || connectionUpdate) && <Box sx={{ backgroundColor: '#ffffff99', position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, zIndex: 100, textAlign: 'center', paddingTop: '20%' }}><GradientCircularLoader /></Box>}
      <Fab onClick={(e) => handleShowModalCreate(e)} sx={fabStyle} color="primary" aria-label="add">
        <AddBusinessIcon />
      </Fab>
      <Box className='dasboard'  sx={{p:0}}>
        <Grid container spacing={2} sx={{ mt: 0 }}>
          <Grid sx={{ backgroundColor: '#FFF', overflowY: 'auto' }} item xs={12} sm={6} md={4}>
            {connectionGetAll && <Box sx={{ backgroundColor: '#ffffff99', textAlign: 'center', paddingTop: '50%' }}><GradientCircularLoader /></Box>}
            {!connectionGetAll && <AvatarList items={mapAvatarList(getAll)} action={handleFindClienById} selected={clientById.id} />}
          </Grid>
          <Grid item sx={{ overflowY: 'auto', p: 0, backgroundColor:'#e4e4e4ed' }} xs={12} sm={6} md={8}>
            {openUpdateHome && edit()}
          </Grid>
        </Grid>
      </Box>
      
      <Modal
        open={openCreate}
        handleClose={handleShowModalCreate}
        dataShow={creation}
        title={"Crear Cliente"}
        actions={buttonCreate}
      />

      <Modal
        open={openUpdate}
        handleClose={handlerShowAndupdate}
        dataShow={showClientForm}
        title={"Actualizar Cliente"}
        actions={buttonUpdate}
        sx={{ display: { xs: 'block', sm: 'none', md: 'none' } }}
      />

    </>
  );
};

export default ClientsTemplate;